<template>
  <form @submit="onSubmit">
    <div
      class="py-4 px-4 sm:px-8 bg-[#F9FAFC] w-full mt-8 flex flex-col gap-y-15 pt-8 rounded-md"
    >
      <!-- File Upload 1 -->
      <div class="flex flex-col gap-y-6">
        <div class="flex gap-x-2 items-center">
          <svg
            viewBox="0 0 51 51"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="w-10 h-10 sm:w-13 sm:h-13"
          >
            <g clip-path="url(#clip0_4197_6477)">
              <path
                d="M0.333984 25.5C0.333984 18.8696 2.96791 12.5107 7.65632 7.82233C12.3447 3.13392 18.7036 0.5 25.334 0.5C31.9644 0.5 38.3232 3.13392 43.0117 7.82233C47.7001 12.5107 50.334 18.8696 50.334 25.5C50.334 32.1304 47.7001 38.4893 43.0117 43.1777C38.3232 47.8661 31.9644 50.5 25.334 50.5C18.7036 50.5 12.3447 47.8661 7.65632 43.1777C2.96791 38.4893 0.333984 32.1304 0.333984 25.5ZM25.334 28.625C24.5052 28.625 23.7103 28.2958 23.1243 27.7097C22.5382 27.1237 22.209 26.3288 22.209 25.5C22.209 24.6712 22.5382 23.8763 23.1243 23.2903C23.7103 22.7042 24.5052 22.375 25.334 22.375C26.1628 22.375 26.9576 22.7042 27.5437 23.2903C28.1297 23.8763 28.459 24.6712 28.459 25.5C28.459 26.3288 28.1297 27.1237 27.5437 27.7097C26.9576 28.2958 26.1628 28.625 25.334 28.625ZM15.959 25.5C15.959 27.9864 16.9467 30.371 18.7049 32.1291C20.463 33.8873 22.8476 34.875 25.334 34.875C27.8204 34.875 30.205 33.8873 31.9631 32.1291C33.7213 30.371 34.709 27.9864 34.709 25.5C34.709 23.0136 33.7213 20.629 31.9631 18.8709C30.205 17.1127 27.8204 16.125 25.334 16.125C22.8476 16.125 20.463 17.1127 18.7049 18.8709C16.9467 20.629 15.959 23.0136 15.959 25.5ZM9.70898 23.9375C9.70898 20.5195 11.418 16.9941 14.123 14.2891C16.8281 11.584 20.3535 9.875 23.7715 9.875C24.6309 9.875 25.334 9.17188 25.334 8.3125C25.334 7.45312 24.6309 6.75 23.7715 6.75C19.3379 6.75 15.0605 8.92773 11.9062 12.0723C8.75195 15.2168 6.58398 19.5039 6.58398 23.9375C6.58398 24.7969 7.28711 25.5 8.14648 25.5C9.00586 25.5 9.70898 24.7969 9.70898 23.9375Z"
                fill="#EEC45C"
              />
            </g>
            <defs>
              <clipPath id="clip0_4197_6477">
                <rect
                  width="50"
                  height="50"
                  fill="white"
                  transform="translate(0.333984 0.5)"
                />
              </clipPath>
            </defs>
          </svg>

          <h3 class="text-xl sm:text-2xl text-black font-medium">Track 1</h3>
        </div>

        <FileUploader v-model="file1" v-bind="file1Attrs" :disabled="isFormDisabled" />

        <!-- Genres -->
        <FieldArray name="gernesFile1" v-slot="{ fields: gernesFile1, push, remove }">
          <div class="flex flex-col gap-y-3">
            <!-- First genre field - always visible -->
            <div class="flex flex-col gap-y-2">
              <label class="font-medium text-[#7B7979] text-base sm:text-lg">{{
                labelGerne[0]
              }}</label>
              <div class="flex flex-row gap-2">
                <Field name="gernesFile1[0]" v-slot="{ field: fieldProps, errors }">
                  <div class="relative grow">
                    <select
                      v-bind="fieldProps"
                      class="w-full appearance-none pr-8"
                      :class="{ 'ring-red-500 border-red-500': errors[0] }"
                      :disabled="isFormDisabled"
                    >
                      <option value="">Select genre</option>
                      <option
                        v-for="genre in availableGenres(gernesFile1, 0)"
                        :key="genre"
                        :value="genre"
                      >
                        {{ genre }}
                      </option>
                    </select>
                    <div
                      class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320 512"
                        class="w-4 h-4"
                      >
                        <path
                          d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
                        />
                      </svg>
                    </div>
                  </div>
                </Field>
              </div>
              <ErrorMessage name="gernesFile1[0]" class="text-sm text-red-500" />
            </div>

            <!-- Additional genre fields -->
            <div
              v-for="(field, index) in gernesFile1.slice(1)"
              :key="field.key"
              class="flex flex-col gap-y-2"
            >
              <label class="font-medium text-[#7B7979] text-base sm:text-lg">{{
                labelGerne[index + 1]
              }}</label>
              <div class="flex flex-row gap-2">
                <Field
                  :name="`gernesFile1[${index + 1}]`"
                  v-slot="{ field: fieldProps, errors }"
                >
                  <div class="relative grow">
                    <select
                      v-bind="fieldProps"
                      class="w-full appearance-none pr-8"
                      :class="{ 'ring-red-500 border-red-500': errors[0] }"
                      :disabled="isFormDisabled"
                    >
                      <option value="">Select genre</option>
                      <option
                        v-for="genre in availableGenres(gernesFile1, index + 1)"
                        :key="genre"
                        :value="genre"
                      >
                        {{ genre }}
                      </option>
                    </select>
                    <div
                      class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320 512"
                        class="w-4 h-4"
                      >
                        <path
                          d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
                        />
                      </svg>
                    </div>
                  </div>
                </Field>
                <button
                  class="btn-form"
                  type="button"
                  @click="() => remove(index + 1)"
                  :disabled="isFormDisabled"
                >
                  -
                </button>
              </div>
              <ErrorMessage
                :name="`gernesFile1[${index + 1}]`"
                class="text-sm text-red-500"
              />
            </div>

            <!-- Add new genre button -->
            <button
              v-if="gernesFile1.length < 3"
              type="button"
              class="w-full btn-form self-start py-2"
              @click="() => push('')"
              :disabled="gernesFile1.length >= 3 || isFormDisabled"
            >
              + Add an additional genre
            </button>
          </div>
        </FieldArray>

        <div class="flex flex-col gap-y-2">
          <label class="font-medium text-[#7B7979] text-base sm:text-lg"
            >Track Mood/Vibe</label
          >
          <Field name="trackMoodFile1" v-slot="{ field, errors }">
            <textarea
              v-bind="field"
              type="text"
              placeholder="Describe the mood (e.g., energetic, laid-back, melancholic)"
              :class="{ 'border-red-500': errors[0] }"
              :disabled="isFormDisabled"
            >
            </textarea>
          </Field>
          <ErrorMessage name="trackMoodFile1" class="text-sm text-red-500"></ErrorMessage>
        </div>
      </div>

      <!-- File Upload 2 -->
      <div class="flex flex-col gap-y-6">
        <div class="flex gap-x-2 items-center">
          <svg
            class="w-10 h-10 sm:w-13 sm:h-13"
            viewBox="0 0 51 51"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_4197_6477)">
              <path
                d="M0.333984 25.5C0.333984 18.8696 2.96791 12.5107 7.65632 7.82233C12.3447 3.13392 18.7036 0.5 25.334 0.5C31.9644 0.5 38.3232 3.13392 43.0117 7.82233C47.7001 12.5107 50.334 18.8696 50.334 25.5C50.334 32.1304 47.7001 38.4893 43.0117 43.1777C38.3232 47.8661 31.9644 50.5 25.334 50.5C18.7036 50.5 12.3447 47.8661 7.65632 43.1777C2.96791 38.4893 0.333984 32.1304 0.333984 25.5ZM25.334 28.625C24.5052 28.625 23.7103 28.2958 23.1243 27.7097C22.5382 27.1237 22.209 26.3288 22.209 25.5C22.209 24.6712 22.5382 23.8763 23.1243 23.2903C23.7103 22.7042 24.5052 22.375 25.334 22.375C26.1628 22.375 26.9576 22.7042 27.5437 23.2903C28.1297 23.8763 28.459 24.6712 28.459 25.5C28.459 26.3288 28.1297 27.1237 27.5437 27.7097C26.9576 28.2958 26.1628 28.625 25.334 28.625ZM15.959 25.5C15.959 27.9864 16.9467 30.371 18.7049 32.1291C20.463 33.8873 22.8476 34.875 25.334 34.875C27.8204 34.875 30.205 33.8873 31.9631 32.1291C33.7213 30.371 34.709 27.9864 34.709 25.5C34.709 23.0136 33.7213 20.629 31.9631 18.8709C30.205 17.1127 27.8204 16.125 25.334 16.125C22.8476 16.125 20.463 17.1127 18.7049 18.8709C16.9467 20.629 15.959 23.0136 15.959 25.5ZM9.70898 23.9375C9.70898 20.5195 11.418 16.9941 14.123 14.2891C16.8281 11.584 20.3535 9.875 23.7715 9.875C24.6309 9.875 25.334 9.17188 25.334 8.3125C25.334 7.45312 24.6309 6.75 23.7715 6.75C19.3379 6.75 15.0605 8.92773 11.9062 12.0723C8.75195 15.2168 6.58398 19.5039 6.58398 23.9375C6.58398 24.7969 7.28711 25.5 8.14648 25.5C9.00586 25.5 9.70898 24.7969 9.70898 23.9375Z"
                fill="#EEC45C"
              />
            </g>
            <defs>
              <clipPath id="clip0_4197_6477">
                <rect
                  width="50"
                  height="50"
                  fill="white"
                  transform="translate(0.333984 0.5)"
                />
              </clipPath>
            </defs>
          </svg>

          <h3 class="text-xl sm:text-2xl text-black font-medium">Track 2</h3>
        </div>
        <FileUploader v-model="file2" v-bind="file2Attrs" :disabled="isFormDisabled" />

        <!-- Genres for File 2 -->
        <FieldArray name="gernesFile2" v-slot="{ fields: gernesFile2, push, remove }">
          <div class="flex flex-col gap-y-3">
            <!-- First genre field - always visible -->
            <div class="flex flex-col gap-y-2">
              <label class="font-medium text-[#7B7979] text-base sm:text-lg">{{
                labelGerne[0]
              }}</label>
              <div class="flex flex-row gap-2">
                <Field name="gernesFile2[0]" v-slot="{ field: fieldProps, errors }">
                  <div class="relative grow">
                    <select
                      v-bind="fieldProps"
                      class="w-full appearance-none pr-8"
                      :class="{ 'ring-red-500 border-red-500': errors[0] }"
                      :disabled="isFormDisabled"
                    >
                      <option value="">Select genre</option>
                      <option
                        v-for="genre in availableGenres(gernesFile2, 0)"
                        :key="genre"
                        :value="genre"
                      >
                        {{ genre }}
                      </option>
                    </select>
                    <div
                      class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320 512"
                        class="w-4 h-4"
                      >
                        <path
                          d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
                        />
                      </svg>
                    </div>
                  </div>
                </Field>
              </div>
              <ErrorMessage name="gernesFile2[0]" class="text-sm text-red-500" />
            </div>

            <!-- Additional genre fields -->
            <div
              v-for="(field, index) in gernesFile2.slice(1)"
              :key="field.key"
              class="flex flex-col gap-y-2"
            >
              <label class="font-medium text-[#7B7979] text-base sm:text-lg">{{
                labelGerne[index + 1]
              }}</label>
              <div class="flex flex-row gap-2">
                <Field
                  :name="`gernesFile2[${index + 1}]`"
                  v-slot="{ field: fieldProps, errors }"
                >
                  <div class="relative grow">
                    <select
                      v-bind="fieldProps"
                      class="w-full appearance-none pr-8"
                      :class="{ 'ring-red-500 border-red-500': errors[0] }"
                      :disabled="isFormDisabled"
                    >
                      <option value="">Select genre</option>
                      <option
                        v-for="genre in availableGenres(gernesFile2, index + 1)"
                        :key="genre"
                        :value="genre"
                      >
                        {{ genre }}
                      </option>
                    </select>
                    <div
                      class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320 512"
                        class="w-4 h-4"
                      >
                        <path
                          d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
                        />
                      </svg>
                    </div>
                  </div>
                </Field>
                <button
                  class="btn-form"
                  type="button"
                  @click="() => remove(index + 1)"
                  :disabled="isFormDisabled"
                >
                  -
                </button>
              </div>
              <ErrorMessage
                :name="`gernesFile2[${index + 1}]`"
                class="text-sm text-red-500"
              />
            </div>

            <!-- Add new genre button -->
            <button
              v-if="gernesFile2.length < 3"
              type="button"
              class="w-full btn-form self-start py-2"
              @click="() => push('')"
              :disabled="gernesFile2.length >= 3 || isFormDisabled"
            >
              + Add an additional genre
            </button>
          </div>
        </FieldArray>

        <!-- Track Mood/Vibe for File 2 -->
        <div class="flex flex-col gap-y-2">
          <label class="font-medium text-[#7B7979] text-base sm:text-lg"
            >Track Mood/Vibe</label
          >
          <Field name="trackMoodFile2" v-slot="{ field, errors }">
            <textarea
              v-bind="field"
              type="text"
              placeholder="Describe the mood (e.g., energetic, laid-back, melancholic)"
              :class="{ 'border-red-500': errors[0] }"
              :disabled="isFormDisabled"
            ></textarea>
          </Field>
          <ErrorMessage name="trackMoodFile2" class="text-sm text-red-500"></ErrorMessage>
        </div>
      </div>
    </div>

    <!-- <div class="flex flex-col w-full px-4 py-8 bg-[#EEF2FD] rounded-md mt-10">
      <h3 class="font-medium text-black text-lg sm:text-xl">
        Please ensure that both checkboxes are selected before submitting
      </h3>
      <div
        class="flex items-start gap-x-0 mt-4 flex-col sm:items-center gap-y-2 sm:flex-row sm:gap-y-2 sm:gap-x-2"
      >
        <div class="sm:contents flex items-center sm:items-start w-full">
          <Field
            name="exclusiveSubmissionAgreement"
            type="checkbox"
            class="h-5 w-full max-w-[20px] cursor-pointer transition-all appearance-none rounded-md border border-slate-300 checked:bg-principal-500 checked:border-principal-500"
            id="exclusiveSubmissionAgreement"
            value="true"
            :disabled="isFormDisabled"
          >
          </Field>
          <label
            for="exclusiveSubmissionAgreement"
            class="text-sm sm:text-base text-black cursor-pointer ml-2"
          >
            I authorize the exclusive use of my work for internal purposes, including
            dataset creation for AI advancements.
          </label>
        </div>
        <ErrorMessage
          name="exclusiveSubmissionAgreement"
          class="text-sm text-red-500 text-center sm:text-start w-max"
        />
      </div>
    </div> -->

    <div class="flex justify-between w-full py-8 px-2 sm:px-0">
      <button
        @click="backStep"
        class="btn-secondary px-4 py-2"
        :disabled="isFormDisabled"
      >
        Back
      </button>
      <!-- <ButtonComponent 
        @click="onSubmit" 
        :class="['btn-primary', 'flex', 'gap-y-2', 'items-center']" 
        :loading="props.loading"
        :disabled="isFormDisabled"
      /> -->
      <button @click="onSubmit" class="btn-primary" :disabled="isFormDisabled">
        Next
      </button>
    </div>
  </form>
</template>

<script setup>
import { defineEmits, onMounted, defineProps, computed } from "vue";
import { useForm, FieldArray, ErrorMessage, Field } from "vee-validate";
import * as yup from "yup";
import FileUploader from "@/shared/component/FileUploader.vue";

const emit = defineEmits(["back", "next"]);
const props = defineProps({
  loading: Boolean,
});


// Computed property to determine if form should be disabled
const isFormDisabled = computed(() => props.loading);

const schema = yup.object({
  file1: yup.mixed().required("File is required"),
  gernesFile1: yup.array().of(yup.string().required("Genre is required")),
  trackMoodFile1: yup.string().required("Track Mood/Vibe is required").min(5, "Track Mood/Vibe must be at least 5 characters").max(500, "Track Mood/Vibe must be at most 500 characters"),
  file2: yup.mixed().required("File is required"),
  gernesFile2: yup.array().of(yup.string().required("Genre is required")),
  trackMoodFile2: yup.string().required("Track Mood/Vibe is required").min(5, "Track Mood/Vibe must be at least 5 characters").max(500, "Track Mood/Vibe must be at most 500 characters"),
  /*exclusiveSubmissionAgreement: yup
    .boolean()
    .required("This field is required")
    .oneOf([true], "This field is required"),*/
});

const { defineField, handleSubmit } = useForm({
  initialValues: {
    gernesFile1: [""],
    gernesFile2: [""],
  },
  validationSchema: schema,
});

const [file1, file1Attrs] = defineField("file1", {
  props: (state) => ({ error: state.errors[0] }),
});
const [file2, file2Attrs] = defineField("file2", {
  props: (state) => ({ error: state.errors[0] }),
});

const onSubmit = handleSubmit(async (values) => {
    emit("next", values);
});

const backStep = () => {
  emit("back");
};

const labelGerne = ["Primary Gerne", "Second Gerne", "Third Genre"];

const allGenres = [
  "Pop",
  "Hip Hop / Rap",
  "R&B",
  "Rock",
  "Electronic / EDM",
  "Reggaeton",
  "Salsa",
  "Bachata",
  "Merengue",
  "Cumbia",
  "K-pop",
  "J-pop",
  "Reggae",
  "Metal",
  "Punk",
  "Country",
  "Soul",
  "Funk",
  "Disco",
];

function availableGenres(genres, currentIndex) {
  const selectedGenres = genres.map((genre, idx) =>
    idx !== currentIndex ? genre.value : null
  );
  return allGenres.filter((genre) => !selectedGenres.includes(genre));
}

onMounted(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
});
</script>
